const airbnb = require('./airbnb.svg')
const amazon = require('./amazon.svg')
const angiesList = require('./angies_list.svg')
const bbb = require('./bbb.svg')
const buildzoom = require('./buildzoom.svg')
const craigslist = require('./craigslist.svg')
const discord = require('./discord.svg')
const email = require('./email.svg')
const etherscan = require('./etherscan.svg')
const etsy = require('./etsy.svg')
const facebook = require('./facebook.svg')
const facebookMarket = require('./facebook_market.svg')
const fiverr = require('./fiverr.svg')
const flickr = require('./flickr.svg')
const globe = require('./globe.svg')
const google = require('./google.svg')
const googleAds = require('./google_ads.svg')
const googleMaps = require('./google_maps.svg')
const houzz = require('./houzz.svg')
const instagram = require('./instagram.svg')
const linkedin = require('./linkedin.svg')
const linktree = require('./linktree.svg')
const midrag = require('./midrag.svg')
const onlyfans = require('./onlyfans.svg')
const opensea = require('./opensea.svg')
const paypal = require('./paypal.svg')
const pinterest = require('./pinterest.svg')
const rarible = require('./rarible.svg')
const shopify = require('./shopify.svg')
const snapchat = require('./snapchat.svg')
const tiktok = require('./tiktok.svg')
const tripadvisor = require('./tripadvisor.svg')
const twitch = require('./twitch.svg')
const twitter = require('./twitter.svg')
const upwork = require('./upwork.svg')
const vimeo = require('./vimeo.svg')
const wantedly = require('./wantedly.svg')
const x = require('./x.svg')
const yelp = require('./yelp.svg')
const youtube = require('./youtube.svg')

export const cryptoSocialIconMap: Record<string, string> = {
  airbnb,
  amazon,
  angies: angiesList,
  angieslist: angiesList,
  bbb,
  buildzoom,
  buildzoompermit: buildzoom,
  craigslist,
  craiglist: craigslist,
  discord,
  discordapp: discord,
  email,
  mailto: email,
  etherscan,
  etsy,
  facebook,
  fb: facebook,
  marketplace: facebookMarket,
  facebookmarket: facebookMarket,
  facebookmarketplace: facebookMarket,
  fiverr,
  flickr,
  globe,
  default_website: globe,
  google,
  googleads: googleAds,
  ads: googleAds,
  googlemaps: googleMaps,
  gmaps: googleMaps,
  maps: googleMaps,
  houzz,
  instagram,
  ig: instagram,
  linkedin,
  linktree,
  linktr: linktree,
  midrag,
  onlyfans,
  opensea,
  paypal,
  pinterest,
  rarible,
  shopify,
  snapchat,
  tiktok,
  tripadvisor,
  twitch,
  twitter,
  x,
  upwork,
  vimeo,
  wantedly,
  yelp,
  youtube,
  youtu: youtube,
}

export const getCryptoSocialIcon = (url: string): string | undefined => {
  try {
    const hostname = new URL(url).hostname.replace(/^www\./, '').toLowerCase()
    const segments = hostname.split('.')
    for (let i = 0; i < segments.length - 1; i += 1) {
      const candidate = segments[i]
      if (cryptoSocialIconMap[candidate]) return cryptoSocialIconMap[candidate]
    }
    return undefined
  } catch {
    return undefined
  }
}
